import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink
} from "@chakra-ui/react";
import {
  match,
  Route,
  RouteComponentProps,
  Switch

} from "react-router";
import { ChevronRightIcon } from "@chakra-ui/icons";
import {
  Link,
  NavLink
} from "react-router-dom";
import { useLayoutEffect } from "react";
import { Page } from "src/components/storyblok/Page";

import { TopicTitles } from "../../components/reduce/topics";
import { FullSpace } from "../../components/shared/FullSpace";
import theme from "../../components/theme";
import {
  kebabCase,
  sentenceCase
} from "../../helpers/string";
import { Wrapper } from "../../components/shared/Wrapper";
import { desktopBreakpointKey } from "../../hooks/useIsDesktop";
import { ReduceRootPage } from "./ReduceRootPage";
import { routes } from "../../constants";
import { SubRouteLinks } from "../../components/reduce/SubRoutesLinks";

export const ReducePage: React.FC<RouteComponentProps> = props => {
  const params = (props.match as match<{reduceSection?: string}>).params;

  useLayoutEffect(() => {
    // because sub-pages were persisting scroll-pos from /reduce page
    window.scrollTo(0, 0);
  }, [ params ]);

  return (
    <FullSpace sx={{ "&>*": { w: "100%" } }}>

      {params.reduceSection && (
        <Wrapper>
          <Breadcrumb
            separator={<ChevronRightIcon color={theme.colors.gray[ 400 ]} />}
            {...breadcrumbGroupStyleProps}
          >
            <BreadcrumbItem>
              <BreadcrumbLink
                as={Link}
                to='/reduce'
              >
                Reduce your carbon
              </BreadcrumbLink>
            </BreadcrumbItem>

            <BreadcrumbItem>
              <BreadcrumbLink
                as={NavLink}
                to='##'
                activeStyle={{
                  pointerEvents: "none",
                  color: "black"
                }}
              >
                {sentenceCase(params.reduceSection)}
              </BreadcrumbLink>
            </BreadcrumbItem>
          </Breadcrumb>
        </Wrapper>
      )}

      <FullSpace>
        <Switch>
          <Route
            path={routes.reduceSection(kebabCase(TopicTitles.ElectricVehicles))}
            component={Page}
          />

          <Route
            path={routes.reduceSection(kebabCase(TopicTitles.HomeEfficiency))}
            component={Page}
          />

          <Route
            path={routes.reduceSection(kebabCase(TopicTitles.SolarPanels))}
            component={Page}
          />

          <Route
            path={routes.reduceSection(kebabCase(TopicTitles.GreenEnergy))}
            component={Page}
          />

          <Route
            path={routes.reduceSection(kebabCase(TopicTitles.Offsets))}
            component={Page}
          />

          <Route
            component={ReduceRootPage}
          />
        </Switch>

        {location.pathname === "/reduce-your-carbon" && (
          <SubRouteLinks />
        )}

      </FullSpace>

    </FullSpace>
  );
};

export default ReducePage;

const breadcrumbGroupStyleProps = {
  spacing: "8px",
  alignSelf: "start",
  color: theme.colors.gray[ 400 ],
  fontSize: {
    base: theme.fontSizes.xs,
    md: theme.fontSizes.sm,
    [ desktopBreakpointKey ]: theme.fontSizes.base
  },
  p: [
    `${theme.spacing[ 6 ]} 0 ${theme.spacing[ 6 ]}`,
    `${theme.spacing[ 12 ]} 0 ${theme.spacing[ 6 ]}`,
    `${theme.spacing[ 16 ]} 0 ${theme.spacing[ 8 ]}`,
    `${theme.spacing[ 24 ]} 0 ${theme.spacing[ 12 ]}`
  ]
};
